export enum ManufacturerName {
  LG = "lg",
  SAMSUMG = "samsung",
  PHILIPS = "philips",
}
